import OverlayManager from "./overlay/js/OverlayManager.js";
/**
 * Base
 */

const start = Date.now()

import("./three.js-Game/Game/Game.js").then(({ default: Game }) => {
    const game = new Game(document.querySelector("canvas.webgl"), start);
    OverlayManager.storeGameInstance(game)
});